import { Controller, useFormContext } from "react-hook-form";
import { SimpleSelect } from "../../../../common/components/Select/SimpleSelect";
import classNames from "classnames";
import { useMemo } from "react";
import { type DropdownEntry } from "~/common/types";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
}

export const enum ABMonitorConfirmedDeliveryStatus {
  ALL = "all",
  CONFIRMED = "confirmed",
  UNCONFIRMED = "unconfirmed",
}
export const ABMonitorLineConfirmedDeliveryEntries: DropdownEntry<string>[] = [
  {
    label: "page.abmonitor.filter.linestatus.all",
    value: ABMonitorConfirmedDeliveryStatus.ALL,
  },
  {
    label: "page.abmonitor.filter.linestatus.confirmed",
    value: ABMonitorConfirmedDeliveryStatus.CONFIRMED,
  },
  {
    label: "page.abmonitor.filter.linestatus.unconfirmed",
    value: ABMonitorConfirmedDeliveryStatus.UNCONFIRMED,
  },
];

export const ConfirmedDeliveryLineFilter = (props: Props) => {
  const formHooks = useFormContext();
  const { t } = useTranslation();

  const values = useMemo(() => {
    return ABMonitorLineConfirmedDeliveryEntries.map((entry) => ({ ...entry, label: t(entry.label as string) }));
  }, [t]);

  return (
    <Controller
      render={({ field: { value, onChange } }) => (
        <SimpleSelect
          label={t("orderList.orderConfirmedDeliveryStatus")}
          className={classNames(props.className)}
          fullWidth={true}
          values={values}
          value={value}
          displayEmpty={true}
          shrink={true}
          onChange={onChange}
          data-test-id={"confirmed-status-select"}
        />
      )}
      name={"confirmedLines"}
      control={formHooks.control}
      defaultValue={ABMonitorLineConfirmedDeliveryEntries[0].value}
    />
  );
};
